module.exports = __webpack_public_path__ + "static/img/04.d355ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build08/assets/images/home/gamelist/04.png
// module id = LQfT
// module chunks = 43